import './index.scss';
import React from 'react';
import createReactClass from 'create-react-class';
import $ from 'jquery';
import _ from 'underscore';
import classnames from 'classnames';
import ModalActionCreator from 'action_creators/modal';
import IntegrationActionCreator from 'action_creators/integration';
import StoreInterestMixin from 'lib/flux/store/interest_mixin';
import { isActionKey } from 'ui_system/utilities/KeyboardHelpers';

var Modal = createReactClass({
  displayName: 'Modal',

  mixins: [StoreInterestMixin],

  getInitialState: function () {
    return {
      visible: false,
      header: null,
      content: null,
      triggeringElement: null,
      actions: null,
      modalHeight: 0,
      className: '',
      parentDetected: false,
      parentViewport: null,
      showIcon: false,
    };
  },

  getStoreInterests: function () {
    return {
      visible: 'modal.visible',
      header: 'modal.header',
      content: 'modal.content',
      triggeringElement: 'modal.triggeringElement',
      actions: 'modal.actions',
      className: 'modal.className',
      settings: 'modal.settings',
      showIcon: 'modal.showIcon',
      parentDetected: 'integration.parentDetected',
      parentViewport: 'integration.parentViewport',
    };
  },

  defaultSettings: function () {
    var _this = this;
    return {
      transition: 'fade up',
      onShow: function () {
        if (_this.refs.viewportAdjust) {
          $(_this.refs.viewportAdjust).show();
        }
      },

      onVisible: function () {
        _this.setState({ modalHeight: this.clientHeight });
      },

      onHide: function () {
        ModalActionCreator.hide();
      },

      onHidden: function () {
        if (_this.refs.viewportAdjust) {
          $(_this.refs.viewportAdjust).hide();
        }
      },
    };
  },

  componentDidUpdate: function (prevProps, prevState) {
    var settings;

    settings = _.extend(
      this.defaultSettings(),
      _.clone(this.state.settings || {}),
      {
        detachable: false,
      }
    );

    if (this.state.visible && !prevState.visible) {
      $(this.refs.modal).modal(settings).modal('show');
    } else if (!this.state.visible && prevState.visible) {
      $(this.refs.modal).not('.out').modal('hide');
    }
  },

  _renderHeader: function () {
    if (this.state.header) {
      return <div className="header">{this.state.header}</div>;
    } else {
      return null;
    }
  },

  _renderContent: function () {
    return <div className="content">{this.state.content}</div>;
  },

  _renderActions: function () {
    if (this.state.actions) {
      return <div className="actions">{this.state.actions}</div>;
    } else {
      return null;
    }
  },

  _renderCloseIcon: function () {
    return (
      <button
        type="button"
        className="ModalClose-Container"
        onClick={this._handleIconClick}
        onKeyDown={(e) => isActionKey(e.key) && this._handleIconClick()}
        data-testid="close-modal"
      >
        <span className="icon af-close" />
      </button>
    );
  },

  _handleIconClick: function () {
    $('body').removeClass('modal-open');
    ModalActionCreator.hide();
  },

  _calculateVerticalAdjust: function () {
    var delta,
      limitDelta = window.innerHeight - this.state.modalHeight;

    if (this.state.parentViewport.get('isConsistent')) {
      delta = this._adjustForConsistentViewport();
    } else {
      delta = this._adjustRelativeToTriggeringElement();
    }

    return {
      top: Math.max(-limitDelta + 10, Math.min(delta, limitDelta - 10)),
    };
  },

  // When we can access all the needed iframe information (i.e. the iframes
  // in the chain of parents are on the same domain)
  _adjustForConsistentViewport: function () {
    var delta, sizeAdjust;

    delta = this.state.parentViewport.get('centersDelta') * 2;
    sizeAdjust =
      this.state.modalHeight - this.state.parentViewport.get('height');
    if (sizeAdjust > 0) delta += sizeAdjust;
    return delta;
  },

  // When we cannot access root viewport info (i.e. WIX sites where the
  // root iframe is on a different domain/cannot be accessed)
  _adjustRelativeToTriggeringElement: function () {
    var delta, triggeringElementTop, frameCenter;

    if (!this.state.triggeringElement) return 0;

    triggeringElementTop =
      this.state.triggeringElement.getBoundingClientRect().top;
    frameCenter = window.innerHeight / 2;
    delta = (triggeringElementTop - frameCenter) * 2;
    return delta;
  },

  render: function () {
    var modalClassName = 'ui modal Modal ' + this.state.className,
      viewportAdjustClassName = classnames({
        'viewport-adjust': true,
        enabled: !!(this.state.parentDetected && this.state.visible),
      }),
      viewportAdjustStyle = this.state.parentDetected
        ? this._calculateVerticalAdjust()
        : {};

    return (
      <div
        className={viewportAdjustClassName}
        style={viewportAdjustStyle}
        ref="viewportAdjust"
      >
        <div className={modalClassName} ref="modal">
          {this.state.showIcon ? this._renderCloseIcon() : null}
          {this._renderHeader()}
          {this._renderContent()}
          {this._renderActions()}
        </div>
      </div>
    );
  },
});

export default Modal;
